var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGridsOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.88889 16C4.52222 16 4.20833 15.8694 3.94722 15.6083C3.68611 15.3472 3.55556 15.0333 3.55556 14.6667V4.88889C3.55556 4.52222 3.68611 4.20833 3.94722 3.94722C4.20833 3.68611 4.52222 3.55556 4.88889 3.55556H14.6667C15.0333 3.55556 15.3472 3.68611 15.6083 3.94722C15.8694 4.20833 16 4.52222 16 4.88889V14.6667C16 15.0333 15.8694 15.3472 15.6083 15.6083C15.3472 15.8694 15.0333 16 14.6667 16H4.88889ZM4.88889 7.24444H14.6667V4.88889H4.88889V7.24444ZM8.57778 10.9778H10.9778V8.57778H8.57778V10.9778ZM8.57778 14.6667H10.9778V12.3111H8.57778V14.6667ZM4.88889 10.9778H7.24444V8.57778H4.88889V10.9778ZM12.3111 10.9778H14.6667V8.57778H12.3111V10.9778ZM4.88889 14.6667H7.24444V12.3111H4.88889V14.6667ZM12.3111 14.6667H14.6667V12.3111H12.3111V14.6667ZM1.33333 12.4444C0.966667 12.4444 0.652778 12.3139 0.391667 12.0528C0.130556 11.7917 0 11.4778 0 11.1111V1.33333C0 0.966667 0.130556 0.652778 0.391667 0.391667C0.652778 0.130556 0.966667 0 1.33333 0H11.1111C11.4778 0 11.7917 0.130556 12.0528 0.391667C12.3139 0.652778 12.4444 0.966667 12.4444 1.33333V2.88889H11.1111V1.33333H1.33333V11.1111H2.88889V12.4444H1.33333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridsOutlined);
export default __webpack_public_path__ + "static/media/grids-outlined.75b41e8e.svg";
export { ForwardRef as ReactComponent };